<div class="col-12 text-center fg-light-purple fs-24px fw-500" [ngClass]="{ 'mb-32px	': viewport.type === 'desktop' }">{{ locale.translations['n736'] }}</div>

<div class="row pt-0" [ngClass]="{ 'px-5 pt-3': viewport.type === 'desktop' }" *ngFor="let data of happyCustomerData; let i = index" id="{{ i }}">
	<div class="col-md-5 col-sm-12 text-section" [ngClass]="{ 'order-2': viewport.type !== 'desktop' }">
		<span [dir]="'rtl'" class="fs-16px fw-500 d-flex text-justify lh-20px feedback" [ngClass]="{ 'fs-24px lh-24px': viewport.type === 'desktop' }">
			{{ data.feedback }}
		</span>

		<div [ngClass]="{ 'divider-container': viewport.type !== 'desktop', 'small-divider-container': viewport.type === 'desktop' }" class="my-4">
			<mat-divider class="divider"></mat-divider>
		</div>

		<audio controls (play)="stopOtherAudios($event.target)" #audios class="audio-player" controlsList="nodownload noplaybackrate">
			<source [src]="data.audioSrc" type="audio/mpeg" />
			Your browser does not support the audio element.
		</audio>
	</div>
	<div class="col-md-7 col-sm-12 image-section" [ngClass]="{ 'mt-2 mb-3 order-1 text-center': viewport.type !== 'desktop' }">
		<img [src]="(viewport.type === 'desktop' ? data.image : data.mobileImage) | s3Image" class="img-fluid w-100 small-image" />
	</div>

	<div class="divider-container my-32px" *ngIf="viewport.type === 'desktop'">
		<mat-divider class="custom-divider"></mat-divider>
	</div>

	<div class="divider-container my-32px" *ngIf="viewport.type !== 'desktop'">
		<mat-divider class="custom-divider-mob"></mat-divider>
	</div>
</div>

<div class="row my-5">
	<div class="col-12 text-center mb-3">
		<span class="fg-purple fs-16px fw-500">{{ locale.translations['n727'] }} {{ locale.translations['n728'] }}</span>
	</div>
	<div class="col-md-6 col-12 mx-auto text-center">
		<div class="d-flex flex-column flex-md-row justify-content-center">
			<button mat-flat-button class="fw-400 w-100 mx-md-2 mb-2 mb-md-0" color="primary" (click)="onOpenWhatsapp()">
				<img
					[src]="'/assets/images/social/whatsapp.svg' | s3Image"
					class="img-responsive wh-18px mb-1"
					[ngClass]="{ 'me-1': locale.lang === 'en', 'ms-1': locale.lang !== 'en' }"
				/>
				{{ locale.translations['n711'] }}
			</button>
			<button mat-stroked-button class="fw-400 w-100 btn-border mx-md-2" color="primary" (click)="onCallCustomerCare()">
				<mat-icon class="fs-18px mt-1 mat-icon-rtl-mirror">phone</mat-icon>
				{{ locale.translations['n712'] }}
			</button>
		</div>
	</div>
</div>
